import { render, staticRenderFns } from "./pa.vue?vue&type=template&id=1073df9d&"
import script from "./pa.vue?vue&type=script&lang=js&"
export * from "./pa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports